import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { config } from '../../config/config';

export const docConfirmationApi = createApi({
  reducerPath: 'docConfirmationApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${config.apiUrl}/doc-confirmation`,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.user?.token;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['Docs', 'Doc'],
  endpoints: (builder) => ({
    listDocs: builder.query({
      query: (params) => ({ url: '/docs', params }),
      providesTags: [{ type: 'Docs', id: 'LIST' }],
    }),
    getDoc: builder.query({
      query: (docId) => `/docs/${docId}`,
      providesTags: (result, err, docId) => [{ type: 'Doc', id: docId }],
    }),
    findByNumber: builder.mutation({
      query: (number) => ({
        url: '/docs/find',
        method: 'POST',
        body: { number },
      }),
    }),
    confirmDoc: builder.mutation({
      query: ({ docId, latitude, longitude }) => ({
        url: `/docs/${docId}/confirm`,
        method: 'POST',
        body: { latitude, longitude },
      }),
      invalidatesTags: (result, err, arg) => [
        { type: 'Docs', id: 'LIST' },
        { type: 'Doc', id: arg.docId },
      ],
    }),
  }),
});

export const {
  useListDocsQuery,
  useGetDocQuery,
  useFindByNumberMutation,
  useConfirmDocMutation,
} = docConfirmationApi;
